import api from './api';

/**
 * @param {string} task_id
 * @returns {Promise<{
 *  test_id: string
 *  is_published: boolean
 *  test_name: string
 *  skill_id: 'speaking' | 'reading_writing' | 'listening'
 * }[]>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tests-getAllTests
 */
export default async function getTestsComponentsByTask(task_id) {
    const { data } = await api.get(`/tests?task_id=${task_id}`);
    return data;
}